import { observable, makeObservable } from 'mobx';

export default class FacetCategory {
  id;

  title;

  facet = [];

  category_label;

  constructor(object) {
    makeObservable(this, {
      id: observable,
      title: observable,
      facet: observable,
      category_label: observable
    });

    this.id = object.sys.id;
    this.title = object.uniqueId;
    this.category_label = object.title;
    this.facet = object.facet != null ? object.facet : [];
  }
}
